export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8572.4508cae3.jpg";